
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.306 11.52L15.828 14l2.48 2.48a1.268 1.268 0 01-1.792 1.793l-2.48-2.48-2.48 2.48a1.268 1.268 0 11-1.793-1.792L12.243 14l-2.478-2.48a1.268 1.268 0 111.793-1.793l2.477 2.48 2.48-2.48a1.268 1.268 0 011.793 1.792l-.002.001zm7.12 2.48a11.39 11.39 0 11-11.39-11.39A11.403 11.403 0 0125.425 14zm-2.531 0a8.86 8.86 0 10-8.86 8.86 8.869 8.869 0 008.86-8.86z","fill":"#B9B9B9"}})])
          )
        }
      }
    